// CUSTOMIZATION:
// line 52 and next: manually added classes to show styles set in sidebar for blocks in grid

import Icon from '@plone/volto/components/theme/Icon/Icon';
import { Button } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import NewBlockAddButton from '@plone/volto/components/manage/Blocks/Container/NewBlockAddButton';
import cx from 'classnames';
import { isInteractiveElement } from '@plone/volto/helpers/Utils/Utils';
import {
  buildStyleObjectFromData,
  blocksFormGenerator,
} from '@plone/volto/helpers/Blocks/Blocks';

import clearSVG from '@plone/volto/icons/clear.svg';

const messages = defineMessages({
  delete: {
    id: 'Remove element {index}',
    defaultMessage: 'Remove element {index}',
  },
  reset: {
    id: 'Reset element {index}',
    defaultMessage: 'Reset element {index}',
  },
});

const EditBlockWrapper = (props) => {
  const intl = useIntl();

  const {
    blockProps,
    draginfo,
    children,
    multipleBlocksColumn = false,
    allowedBlocks,
  } = props;
  const {
    block,
    selected,
    type,
    blocksConfig,
    onChangeBlock,
    onDeleteBlock,
    onSelectBlock,
    data,
    index,
    onChangeFormData,
  } = blockProps;

  function onResetBlock() {
    onChangeBlock(block, { '@type': 'empty' });
  }

  function clearBlock() {
    const newBlock = blocksFormGenerator(1, type);
    onChangeFormData(newBlock);
  }

  const style = buildStyleObjectFromData(data);

  return (
    <div
      ref={draginfo.innerRef}
      {...draginfo.draggableProps}
      {...draginfo.dragHandleProps}
      className={cx(`block-editor-${data['@type']} contained`, {
        selected,
        'has--title_color--red': data?.styles?.title_color === 'red',
        'has--title_color--black': data?.styles?.title_color === 'black',
        'has--title_color--gray': data?.styles?.title_color === 'gray',
        'has--title_color--white': data?.styles?.title_color === 'white',
        'has--bg--white': data?.styles?.bg === 'white',
        'has--bg--black': data?.styles?.bg === 'black',
        'has--bg--gray': data?.styles?.bg === 'gray',
        'has--align--left': data?.styles?.align === 'left',
        'has--align--center': data?.styles?.align === 'center',
        'has--uppercase_title--true': data?.styles?.uppercase_title,
        'has--cardBg--gray': data?.styles?.cardBg === 'gray',
        'has--cardBg--white': data?.styles?.cardBg === 'white',
        'has--cardBg--black': data?.styles?.cardBg === 'black',
        'has--show_as_card--true': data?.styles?.show_as_card,
      })}
      style={style}
    >
      <div
        role="presentation"
        className="cell-wrapper"
        onClick={(e) => {
          e.block = block;
          onSelectBlock(block);
        }}
      >
        {type !== 'empty' ? (
          <Button
            aria-label={intl.formatMessage(messages.reset, {
              index,
            })}
            type="button"
            basic
            icon
            // if only one block is allowed, we don't want to reset the block choice
            // we want to remove the block altogether.
            onClick={(e) => {
              if (allowedBlocks?.length > 1 || !allowedBlocks) {
                onResetBlock(block, {});
              } else {
                if (multipleBlocksColumn) {
                  onDeleteBlock(block, true);
                } else {
                  clearBlock();
                }
              }
            }}
            className="remove-block-button"
          >
            <Icon name={clearSVG} className="circled" size="24px" />
          </Button>
        ) : (
          <Button
            type="button"
            basic
            icon
            className="remove-block-button"
            onClick={(e) => onDeleteBlock(block, true)}
            aria-label={intl.formatMessage(messages.delete, {
              index,
            })}
          >
            <Icon
              name={clearSVG}
              className="circled"
              size="24px"
              color="#e40166"
            />
          </Button>
        )}
        {type && type !== 'empty' ? (
          <div className={cx('ui drag block inner', type)}>{children}</div>
        ) : (
          <div
            className={cx('gridBlock-empty-placeholder', {
              selected: selected,
            })}
            role="presentation"
            onClick={(e) => {
              onSelectBlock(block);
              // If the click is in the button, then
              if (isInteractiveElement(e.target)) {
                e.stopPropagation();
              }
            }}
          >
            <p>Add a new block</p>
            <NewBlockAddButton
              block={block}
              index={index}
              blocksConfig={blocksConfig}
              onMutateBlock={(block, value) =>
                onChangeBlock(block, {
                  ...data,
                  ...value,
                })
              }
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default EditBlockWrapper;
